export default __webpack_public_path__ + "static/media/ic-customer-info.32175ca6.svg";